<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
<h2>{{'NOTIFICATIONS.TITLE' | translate}}</h2>

<ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'notification'"
               [disableHeader]="false"
               (onQuery)="onGridQuery($event)"
               [columns]="columns"
               [actionButtons] = false
               [referenced] = true
               [headers]="['','Type','Created By','Date', 'Action']">
</ntr-datatable>
</div>